import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// On web, JWT lives in an httpOnly cookie set by the backend (`atelier_access`).
// On native (Capacitor iOS/Android), that cookie is not reliably shared with
// requests, so we fall back to a Bearer token stored in localStorage.
const isNativePlatform = () => {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  if (!cap || typeof cap.getPlatform !== "function") return false;
  const p = cap.getPlatform();
  return p === "ios" || p === "android";
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true, // send httpOnly auth cookie on web
});

api.interceptors.request.use((cfg) => {
  // SECURITY NOTE: Web browsers use the `atelier_access` httpOnly cookie set by
  // the backend on login/register. localStorage is used ONLY on Capacitor
  // iOS/Android where cookies are unreliable across capacitor:// origins.
  // Native apps ship over signed store binaries and have no XSS attack surface
  // for third-party JS, so a Bearer token in localStorage is acceptable there.
  if (isNativePlatform()) {
    const t = localStorage.getItem("atelier_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

// 402 → paywall
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402 && typeof window !== "undefined") {
      if (!window.location.pathname.startsWith("/pricing")) {
        window.location.href = "/pricing?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

// Only persist a token on native platforms (web uses httpOnly cookies).
export const setToken = (t) => {
  if (!isNativePlatform()) return;
  if (t) localStorage.setItem("atelier_token", t);
  else localStorage.removeItem("atelier_token");
};

export const errText = (err, fallback = "Something went wrong") => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || String(x)).join(", ");
  if (typeof d === "object") return d.msg || JSON.stringify(d);
  return fallback;
};
